import type { CorpusAdmission, CorpusStatus } from '@rp/contracts'

export const CORPUS_PREVIEW_MAX_CHARS = 40

export const CORPUS_COPY = {
  title: '核准回覆',
  intro: 'AI 草擬建議時會參考這些已核准的答案。下架之後，新的建議不會再引用它。',
  forbidden: '你沒有權限查看核准回覆',
  forbiddenBody: '請聯絡公司的管理員。',
  loading: '載入核准回覆…',
  loadFailed: '載入核准回覆失敗',
  retry: '重新載入',
  statuses: '狀態',
  entries: '核准回覆清單',
  question: '客人問',
  admittedBy: (name: string) => `由 ${name} 加入`,
  retiredOn: (when: string) => `${when} 下架`,
  retire: '下架',
  retiring: '下架中…',
  confirmRetireTitle: '確認下架核准回覆',
  confirmRetireBody: (preview: string) => `下架後，「${preview}」不會再用來生成建議。已經發送給客人的回覆不受影響。`,
  confirmRetireCancel: '取消',
  confirmRetireConfirm: '確認下架',
  retireFailed: '無法下架這則核准回覆',
  openConversation: '查看對話',
  empty: { active: '未有使用中的核准回覆', retired: '未有已下架的核准回覆' },
  emptyBody: '核准人員發送回覆之後，那則回覆會自動成為核准回覆。',
  pagination: '分頁',
  previousPage: '上一頁',
  nextPage: '下一頁',
  pageStatus: (page: number, total: number, limit: number) =>
    `第 ${page} 頁，共 ${Math.max(1, Math.ceil(total / limit))} 頁（${total} 個項目）`,
} as const

export const CORPUS_STATUS_LABELS: Record<CorpusStatus, string> = {
  active: '使用中',
  retired: '已下架',
}

export const CORPUS_ADMISSION_LABELS: Record<CorpusAdmission, string> = {
  approver_post: '核准人員發送',
  endorsement: '人手加入',
}

const RETIRE_REASON_LABELS: Record<string, string> = {
  source_updated: '來源已更新',
  source_deleted: '來源已移除',
  retired_by_approver: '由核准人員下架',
}

export const retireReasonLabel = (reason: string | null): string =>
  reason === null ? CORPUS_STATUS_LABELS.retired : (RETIRE_REASON_LABELS[reason] ?? CORPUS_STATUS_LABELS.retired)

export const previewOf = (text: string): string =>
  text.length <= CORPUS_PREVIEW_MAX_CHARS ? text : `${text.slice(0, CORPUS_PREVIEW_MAX_CHARS)}…`
